export default "__VITE_ASSET__xlCn3OaQ__"